import { render, staticRenderFns } from "./globaldivecenterList.vue?vue&type=template&id=6b6757a2&scoped=true&"
import script from "./globaldivecenterList.vue?vue&type=script&lang=js&"
export * from "./globaldivecenterList.vue?vue&type=script&lang=js&"
import style0 from "./globaldivecenterList.vue?vue&type=style&index=0&id=6b6757a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6757a2",
  null
  
)

export default component.exports